import { useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { RemoteApiError } from "../useRemote/types";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { BookingType } from "../../../features/Booking-Form/typings/booking-inputs";

/**
 * Payload for POST /fleet/bookings/on-behalf (VehicleBookingDto).
 */
export type BookOnBehalfFleetPayload = {
  users: Array<{ userId: string; bookingInventoryId?: number }>;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  bookingType: BookingType.VEHICLE;
  locationInventoryId?: number;
  tripReason?: string;
};

/**
 * Book a fleet vehicle on behalf of another user (POST /fleet/bookings/on-behalf).
 * Use mutateAsyncSafe when calling from UI so errors are handled in the hook and the promise never rejects.
 */
export function useRemoteBookOnBehalfFleetBooking() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useRemoteMutation<void, RemoteApiError, BookOnBehalfFleetPayload>({
    key: ["fleet", "book-on-behalf"],
    url: "/fleet/bookings/on-behalf",
    method: "post",
    snackbarTextOnSuccess: t("Booking created on behalf"),
    onSuccess: () => {
      queryClient.invalidateQueries(["fleet", "vehicles"]);
    }
  });
}
